// Espelha PlanoTrabalhoWorkflow.ETAPAS_ORDENADAS (backend) — mantenha em sincronia.
export const ETAPAS_PLANO_ORDENADAS = [
  'ORCAMENTO',
  'CONVENIOS_ANALISE',
  'GESTOR_PARCERIA',
  'COMISSAO_SELECAO',
  'CONVENIOS_MINUTA',
  'PROCURADORIA_JURIDICA',
  'GESTOR_JURIDICO_REVISAO',
  'CONVENIOS_FORMALIZACAO',
  'CONCLUIDO',
] as const;

export const ETAPA_PLANO_LABEL: Record<string, string> = {
  ORCAMENTO: 'Orçamento',
  CONVENIOS_ANALISE: 'Análise',
  GESTOR_PARCERIA: 'Gestor parceria',
  COMISSAO_SELECAO: 'Comissão',
  CONVENIOS_MINUTA: 'Minuta',
  PROCURADORIA_JURIDICA: 'Jurídico',
  GESTOR_JURIDICO_REVISAO: 'Revisão jurídica',
  CONVENIOS_FORMALIZACAO: 'Formalização',
  CONCLUIDO: 'Concluído',
};

export interface EtapaPlanoInfo {
  /** Índice 0-based na ordem do fluxo (-1 se não reconhecida). */
  index: number;
  /** Total de etapas do fluxo. */
  total: number;
  /** Passo 1-based (index + 1), ou null se não reconhecida. */
  passo: number | null;
  /** Rótulo amigável da etapa. */
  label: string;
}

/** Resolve a posição da etapa atual no fluxo, ou null quando não há etapa. */
export function etapaPlanoInfo(etapaAtual?: string | null): EtapaPlanoInfo | null {
  if (!etapaAtual) return null;
  const total = ETAPAS_PLANO_ORDENADAS.length;
  const index = ETAPAS_PLANO_ORDENADAS.indexOf(etapaAtual as (typeof ETAPAS_PLANO_ORDENADAS)[number]);
  return {
    index,
    total,
    passo: index >= 0 ? index + 1 : null,
    label: ETAPA_PLANO_LABEL[etapaAtual] ?? etapaAtual,
  };
}
